import api from "api/api";

export const getMissionBalanceSheetWithSlugTokenQuery = async ({
  slug,
  token,
}) => await api.get(`/balancesheet/mission/slug/${slug}/${token}`);

export const getMissionBalanceSheetWithSlugIdQuery = async ({
  missionId,
  evaluationId,
}) => await api.get(`/balancesheet/mission/${missionId}/${evaluationId}`);

export const saveEvaluationMissionQuery = async ({ id, data }) =>
  await api.post(`/balancesheet/mission/save/${id}`, data);

export const createMissionBalancesheetWithIdQuery = async ({ missionId, data }) => {
  const response = await api.post(`/balancesheet/mission/id/${missionId}/generate`, data);
  return response;
};

